export enum WebsocketEvents {
  NEW_NOTIFICATION = 'new-notification',
  UPDATE_NEW_CATEGORY = 'update-category',
  SET_HAS_NEW_TOPICS = 'set-has-new-topics',
  LOGOUT = 'logout',
}
